import AgentActivity from 'models/agent_activity';
import { AgentAvailability } from 'models/agent_status';
import { handleErrorInteractively, updateStore } from 'actions/agent_status/lib/agent_status';
import { logStatusActivity } from 'actions/agent_status/lib/agent_activity';

export default class GoAway {
  constructor(context) {
    this.context = context;
  }

  run({ reasonId }) {
    if (this.store.get().getAvailability() === AgentAvailability.AWAY) {
      return;
    }

    this.setAwayPending(reasonId);

    this.context.gateways.agentStatus
      .update({ availability: AgentAvailability.AWAY, awayReasonId: reasonId })
      .then(response => this.handleSuccess(response))
      .catch(err => this.handleError(err));

    logStatusActivity(this.context, AgentActivity.Type.AWAY, { reasonId });

    this.context.capacityManager.stop();

    const reason = this.context.stores.agentStatusReasons.find(reasonId);
    this.context.analytics.track('Agent Status Reason Updated', { id: reason.id, name: reason.name, type: 'AWAY' });
  }

  handleError(err) {
    this.context.capacityManager.start();
    handleErrorInteractively(this.context, err);
  }

  handleSuccess(response) {
    this.store.resetPending();
    updateStore(this.context, response);
  }

  setAwayPending(reasonId) {
    let status = this.store.get();
    status.setAway(reasonId);
    status.incrementVersion();
    this.store.setPending(status);
  }

  get store() {
    return this.context.stores.agentStatus;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/agent_status/go_away.js